import React from "react";
import CoinAnimation from "./coin-animation.json";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import useBreakpoint from "../../utils/useBreakpoint";
import Lottie from "lottie-react";
import CoinBlue from "../../images/Carbo-X-Blue.svg";
import CoinGreen from "../../images/Carbo-X-Green.svg";

function WelcomeCard() {
  const organizationName = useSelector(
    (state) => state?.auth?.user?.organizations?.[0]?.name
  );

  console.log(organizationName);

  const { isMobile, isTable } = useBreakpoint();

  return (
    <div class="welcome-card">
      <h5>
        Introducing <span class="red-text">Carbo- X Tokens</span>
      </h5>
      <p>
        We have incorporated carbon credits into Carbo-X tokens via blockchain
        technology which is completely transparent, traceable and safe. 
        <br></br>Offset
        your Carbon footprint now!{" "}
      </p>
      <div>
        <Link type="submit" to={`/buy-tokens`} class="new-btn">
          Buy Tokens
        </Link>
      </div>
    </div>
  );
}

export default WelcomeCard;
